import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { ApplicationParent } from '@shared/models/data/application-parent.model';
import { FormModule } from '@shared/models/data/form-module.model';
import { ApplicationService } from '@shared/services/administration/application.service';
import { of } from 'rxjs';
import { catchError, concatMap, finalize, switchMap } from 'rxjs/operators';

@Component({
  selector: 'app-view-applicant',
  templateUrl: './view-applicant.component.html',
  styleUrls: ['./view-applicant.component.scss']
})
export class ViewApplicantComponent implements OnInit {

  parent: ApplicationParent;
  id: string;
  modules: FormModule[];
  applicationHtml: string;
  loading = false;

  constructor(
    private applicationService: ApplicationService,
    private route: ActivatedRoute) { }

  ngOnInit(): void {



    this.route.queryParams.pipe(
      concatMap(params => {
        this.id = params['id'];
        this.loading = true;
        return this.applicationService.getApplicationHtml(this.id).pipe(
          catchError(error => {
            this.applicationHtml = '<p>Error loading application</p>';
            return of(null); // fallback value
          }),
          finalize(() => {
            this.loading = false;
          })
        );
      })
    ).subscribe(html => {
      if (html) {
        this.applicationHtml = html;
      }
    });
  }
}
